import AppDataService from "./AppDataService";

const COMMON_BASE_FORMS = 'Forms'

export default class Form1094cDataService {
    static async getFormFields(formId, formYear, payerId) {
        return await AppDataService.get(`${COMMON_BASE_FORMS}/GetFormFields?formName=${formId}&year=${formYear}&payerId=${payerId}`);
    }

    static async getFormByRecordId(formId, formRecordId) {
        return await AppDataService.get(`${COMMON_BASE_FORMS}/GetForm?FormName=${formId}&formRecordId=${formRecordId}`);
    }

    static async getFormData(formId, formYear, payerId) {
        return await AppDataService.get(`${COMMON_BASE_FORMS}/GetFormData?formId=${formId}&year=${formYear}&payerId=${payerId}`);
    }

    static async calculateInferredValues(onDependentFieldChangeData) {
        return await AppDataService.post(`${COMMON_BASE_FORMS}/CalculateInferredValues`, onDependentFieldChangeData);
    }

    static async saveForm(formData) {
        return await AppDataService.post(`${COMMON_BASE_FORMS}/Save`, formData);
    }
}